import React from 'react';

const CareerButton = (props) => {
  const {
    onClick, icon, text, topPosition, leftPosition,
  } = props;

  return (
    <button
      aria-label={text}
      tabIndex="0"
      style={{ top: topPosition, left: leftPosition }}
      onClick={onClick}
      className="career-button"
    >
      <img className="career-button__icon" src={icon} alt="missing" />
      <p className="career-button__text">
        { text }
      </p>
    </button>
  );
};

export default CareerButton;



// WEBPACK FOOTER //
// ./src/Components/Career/CareerButton.js